import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PuzzleList from '../features/puzzles/PuzzleList';
import JigsawGame from '../features/jigsaw/JigsawGame';
import Login from '../features/auth/Login';
import Welcome from '../features/auth/Welcome';
import BrandIntro from '../features/auth/BrandIntro';
import Layout from '../components/common/Layout';
import Quests from '../features/pages/Quests';
import Profile from '../features/pages/Profile';
import CategoryPage from '../features/pages/CategoryPage';
import Statistics from '../features/pages/Statistics';
import Collection from '../features/pages/Collection';
import Settings from '../features/pages/Settings';
import { getUserProfile } from '../services/userProfileService';

const Routes = () => {
    const [showBrandIntro, setShowBrandIntro] = useState(false);
    const [showWelcome, setShowWelcome] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check if user has seen intro THIS SESSION (sessionStorage clears on browser close)
        const seenIntroThisSession = sessionStorage.getItem('puzzzled_intro_seen_session');
        // Check if user has ever been welcomed (localStorage persists)
        const seenWelcome = localStorage.getItem('puzzzled_welcomed');

        // Always show intro once per session for preloading
        if (!seenIntroThisSession) {
            setShowBrandIntro(true);
        } else if (!seenWelcome) {
            // Only show welcome if they've never completed it
            setShowWelcome(true);
        }

        setLoading(false);
    }, []);

    const handleIntroComplete = () => {
        // Mark intro as seen for THIS session only
        sessionStorage.setItem('puzzzled_intro_seen_session', 'true');
        setShowBrandIntro(false);
        
        // Check if they still need to see welcome
        const seenWelcome = localStorage.getItem('puzzzled_welcomed');
        if (!seenWelcome) {
            setShowWelcome(true);
        }
    };

    const handleWelcomeComplete = () => {
        localStorage.setItem('puzzzled_welcomed', 'true');
        setShowWelcome(false);
    };

    if (loading) {
        return <div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div>;
    }

    // Show brand intro
    if (showBrandIntro) {
        return (
            <BrandIntro
                onComplete={handleIntroComplete}
            />
        );
    }

    // Show welcome screen
    if (showWelcome) {
        return (
            <Welcome onComplete={handleWelcomeComplete} />
        );
    }

    // Show game
    return (
        <Layout>
            <Switch>
                <Route path="/" exact component={PuzzleList} />
                <Route path="/play/:id" component={JigsawGame} />
                <Route path="/category/:categoryId" component={CategoryPage} />
                <Route path="/quests" component={Quests} />
                <Route path="/profile" component={Profile} />
                <Route path="/stats" component={Statistics} />
                <Route path="/collection" component={Collection} />
                <Route path="/settings" component={Settings} />
                <Route path="/login" component={Login} />
            </Switch>
        </Layout>
    );
};

export default Routes;